// src/pages/CustomersPage.jsx
import React, { useEffect} from 'react';
import PageContainer from '../layouts/PageContainer';
import PageHeader from '../components/Nav/PageHeader';
import CardComponent from '../components/Common/CardComponent';
import WifiMetricMiniCard from '../components/Dashboard/WifiMetricMiniCard';
import { useCustomer } from '../DataStore/CustomerContext';
import { SkeletonBar } from '../util/skeleton/Skeleton';
import StarterPanel from '../components/Dashboard/StarterPanel';
import { numberFormat } from '../util/araknerdlib';
import Pagination from '../components/Common/Pagination';
import DeviceFilterBar from '../components/Devices/DeviceFilterBar';
import { useNavigate } from 'react-router-dom';


const CustomerKPIRow = ({ total = 0, active24h = 0, newToday = 0 }) => (
  <div className="d-flex justify-content-end align-items-center py-3 px-4 rounded">
    <WifiMetricMiniCard
      label="Total Devices"
      value={numberFormat(total, {minDigits: 2})}
      icon="fas fa-users"
      iconColor="text-info"
    />
    <div className="border-left mx-3" style={{ height: 30 }} />

    <WifiMetricMiniCard
      label="Active (24h)"
      value={numberFormat(active24h)}
      icon="fas fa-clock"
      iconColor="text-success"
    />
    <div className="border-left mx-3" style={{ height: 30 }} />

    <WifiMetricMiniCard
      label="New Today"
      value={numberFormat(newToday)}
      icon="fas fa-user-plus"
      iconColor="text-primary"
    />
  </div>
);


const CustomersPage = () => {

  const {
    customers,           // null | [{ mac, first_seen, last_seen, sessions, total_bytes, last_router, ...}]
    customerKPIs,     // optional server KPIs: { total, active24h, newToday }
    getCustomers,  // (filters) => Promise
    getCustomerKPIs,  // (filters) => Promise
    setMounted,
    metaData,
    setCurrentPage,
    filters,
    setFilters,
  } = useCustomer();

  const navigation = useNavigate();

  // Initial load
  useEffect(() => {
    getCustomers();
    getCustomerKPIs();
    setMounted?.(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const k = customerKPIs

  const handleApply = () => {
    getCustomers(filters);
    getCustomerKPIs?.(filters);
  };

  const handleReset = () => {
    const reset = { q: '', from: '', to: '' };
    setFilters(reset);
  };

  const onRefresh = () => {
    getCustomers(true);
    getCustomerKPIs(true);
  };

  const handleMacClick = (mac) => {
    navigation(`/network-device?m=${mac}`);
  };

  return (
    <PageContainer>
      <PageHeader
        title="Network Users"
        breadcrumb={<li className="breadcrumb-item active" aria-current="page">Network Users</li>}
         primaryButtons={[
          
            {
                label: 'Refresh',
                icon: 'fas fa-sync',
                className: 'btn-outline-secondary',
                onClick: onRefresh
            }
    ]}
      />

        <div className="row">
        <StarterPanel greetingText='Hi'/>
        <div className="col-lg-8 mb-4">
          <CustomerKPIRow total={k.total} active24h={k.active24h} newToday={k.newToday} />
        </div>
      </div>

      {/* Filters */}
     <DeviceFilterBar
       filters={filters}
       setFilters={setFilters}
       handleApply={handleApply}
       handleReset={handleReset}
     />

      {/* Table */}
      <CardComponent title="Unique Devices" subtitle="De-duplicated by MAC address">
        <div className="table-responsive overflow-auto" style={{maxHeight: '400px'}}>
          <table className="table table-hover table-striped align-middle mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>MAC</th>
                <th>Nickname</th>
                <th>First Seen</th>
                <th>Last Seen</th>
                <th>Last IP</th>
                <th className="text-right">Sessions</th>
                <th className="text-right">Upload</th>
                <th className="text-right">Download</th>
              </tr>
            </thead>

            {/* Loading */}
            {customers === null && (
              <tbody>
                {Array.from({ length: 8 }).map((_, i) => (
                  <tr key={i}>
                    <td colSpan={9}>
                      <SkeletonBar h={18} />
                    </td>
                  </tr>
                ))}
              </tbody>
            )}

            {/* Data */}
            {Array.isArray(customers) && (
              <tbody>
                {customers.map((c, i) => (
                  <tr key={c.mac || i}>
                    <td>{i + 1}</td>
                    <td>
                      <span className='link' onClick={()=>handleMacClick(c.device_token)}>
                       <code className="text-monospace">{c.mac || '—'}</code>
                      </span>
                    </td>
                    <td>{c.device_name ? c.device_name.nickname || '—' : '—'}</td>
                    <td>{c.first_seen || '—'}</td>
                    <td>{c.last_seen || '—'}</td>
                    <td>{c.last_ip || '—'}</td>
                    <td className="text-center">{c.sessions || '—'}</td>
                    <td className="text-right">{c.upload_bps}</td>
                    <td className="text-right">{c.download_bps}</td>
                  </tr>
                ))}
              </tbody>
            )}

              {customers === "404"&& (<tbody>
                  <tr>
                    <td colSpan="9" className="text-center text-muted py-4">
                      No devices found.
                    </td>
                  </tr>
                  </tbody>
                )}
              

          </table>
        </div>

         {metaData && <div className="card-footer d-flex justify-content-between align-items-center">
          <div className="text-muted small">Showing {metaData.total} device(s)</div>
          <Pagination
              metaData={metaData}
              onPageChange={(page) => setCurrentPage(page)}
          /> 
        </div>}
      </CardComponent>
    </PageContainer>
  );
};

export default CustomersPage;
